/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /press_release/{release_id}/migrate
 * @export
 * @interface MigratePressReleaseEditorVersionResponse
 */
export interface MigratePressReleaseEditorVersionResponse {
    /**
     * 
     * @type {number}
     * @memberof MigratePressReleaseEditorVersionResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof MigratePressReleaseEditorVersionResponse
     */
    message: string;
}

export function MigratePressReleaseEditorVersionResponseFromJSON(json: any): MigratePressReleaseEditorVersionResponse {
    return MigratePressReleaseEditorVersionResponseFromJSONTyped(json, false);
}

export function MigratePressReleaseEditorVersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigratePressReleaseEditorVersionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function MigratePressReleaseEditorVersionResponseToJSON(value?: MigratePressReleaseEditorVersionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

